import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './AppPromotionModal.styled';
import { REDIRECT_LOADER_DURATION } from './AppPromotionModal.constants';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { checkRoute } from '@/components/CustomLink/CustomLink.helpers';
import { ROUTES } from '@/constants/routes';
import { Modal } from '@/components/UI/Modal';

interface AppPromotionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const AppPromotionModal = ({
  isOpen,
  onClose,
}: AppPromotionModalProps) => {
  const { isDesktop } = useBreakpoint();
  const { t, i18n } = useTranslation();
  const [isRedirecting, setIsRedirecting] = useState(false);
  const texts = 'pages.bookmarks.app_promotion_popup';
  const imgName = isDesktop ? 'desktop' : `mobile-${i18n.language}`;
  const buttonText = isDesktop
    ? t(`${texts}.desktop_button`)
    : t(`${texts}.mobile_button`);

  const handleClick = () => {
    if (isDesktop) {
      onClose();
    } else {
      setIsRedirecting(true);
      const { hrefString } = checkRoute(ROUTES.savedSearches, {
        isDesktop: false,
        lang: i18n.language,
      });
      window.open(hrefString, '_blank');
      setTimeout(() => {
        setIsRedirecting(false);
        onClose();
      }, REDIRECT_LOADER_DURATION);
    }
  };

  return (
    <Modal isOpen={isOpen} maxWidth={420} borderRadius={32}>
      <S.AppPromotionModalContent>
        <S.AppPromotionModalCloseBtn onClick={onClose}>
          <S.AppPromotionModalCloseIcon />
        </S.AppPromotionModalCloseBtn>
        <S.AppPromotionModalBgImg />
        <S.AppPromotionModalImg $imgName={imgName} />
        <S.AppPromotionModalTexts>
          <S.AppPromotionModalTitle>
            {t(`${texts}.title`)}
          </S.AppPromotionModalTitle>
          <S.AppPromotionModalDescription>
            {t(`${texts}.description`)}
          </S.AppPromotionModalDescription>
        </S.AppPromotionModalTexts>
        <S.AppPromotionModalBtn
          onClick={handleClick}
          isLoading={isRedirecting}
          disabled={isRedirecting}
        >
          {buttonText}
        </S.AppPromotionModalBtn>
      </S.AppPromotionModalContent>
    </Modal>
  );
};
